// extracted by mini-css-extract-plugin
export var countText = "styles-module--countText--FInI4";
export var succesesBlock = "styles-module--succesesBlock--9ncan";
export var succesesBlockContainer = "styles-module--succesesBlock-container--eePUQ";
export var succesesBlockInner = "styles-module--succesesBlock-inner--6ILJF";
export var succesesBlockSubtitle = "styles-module--succesesBlock-subtitle--igxhh";
export var succesesBlockBtn = "styles-module--succesesBlock-btn--O277z";
export var failBlockInner = "styles-module--fail-block-inner--anR9b";
export var failBlockImg = "styles-module--fail-block-img--fkB0n";
export var failBlock = "styles-module--fail-block--1SCIJ";
export var failBlockSubtitle = "styles-module--fail-block-subtitle--etGUJ";